const tickets = state => state.support.tickets;
const countUnreadMessages = state => state.support.countUnreadMessages;
const ticketTopics = state => state.support.ticketTopics;
const createdTicketStatus = state => state.support.createdTicketStatus;
const ticket = state => state.support.ticket;
const dialog = state => state.support.dialog;
const addMessageStatus = state => state.support.addMessageStatus;

export default {
  tickets,
  countUnreadMessages,
  ticketTopics,
  createdTicketStatus,
  ticket,
  dialog,
  addMessageStatus,
};
